import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { authService } from "../../app/services/authService";
import { toast } from "react-toastify";

const initialState = { user: null, session: null, error: null, loading: true };

const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(signUp.fulfilled, (state, action) => {
        state.user = action.payload.user;
        state.session = action.payload.session;
        state.error = null;
        state.loading = false;
      })
      .addCase(signIn.fulfilled, (state, action) => {
        state.user = action.payload.user;
        state.session = action.payload.session;
        state.error = null;
        state.loading = false;
      })
      .addCase(signInWithGoogle.fulfilled, (state, action) => {
        state.user = action.payload.user;
        state.session = action.payload.session;
        state.error = null;
        state.loading = false;
      })
      .addCase(signInWithFacebook.fulfilled, (state, action) => {
        state.user = action.payload.user;
        state.session = action.payload.session;
        state.error = null;
        state.loading = false;
      })
      .addCase(signOut.fulfilled, () => initialState)
      .addCase(getCurrentUser.fulfilled, (state, action) => {
        state.user = action.payload?.user;
        state.session = action.payload;
        state.error = null;
        state.loading = false;
      })
      .addMatcher(
        (action) => action.type.endsWith("/pending"),
        (state) => {
          console.log("pending");
          state.loading = true;
        }
      )
      .addMatcher(
        (action) => action.type.endsWith("/rejected"),
        (state, action) => {
          state.error = action.error.message;
          state.loading = false;
        }
      );
  },
});

export default authSlice.reducer;

export const signUp = createAsyncThunk("auth/signUp", async (authData) => {
  
  // return await authService.signUp(authData);
  return await authService.signUp(authData);
});

export const signIn = createAsyncThunk("auth/signIn", async (authData) => {
  return await authService.signIn(authData);
});

export const signInWithGoogle = createAsyncThunk("auth/signInWithGoogle", async (authData) => {
  return await authService.signInWithGoogle(authData);
});

export const signInWithFacebook = createAsyncThunk("auth/signInWithFacebook", async (authData) => {
  return await authService.signInWithFacebook(authData);
});

export const signOut = createAsyncThunk("auth/signOut", async () => {
  return await authService.signOut();
});

export const changePassword = createAsyncThunk(
  "auth/changePassword",
  async (data) => {
    return await authService.changePassword(data);
  }
);

export const getCurrentUser = createAsyncThunk(
  "auth/getCurrentUser",
  async () => {
    return await authService.getCurrentUser();
  }
);

export const selectAuth = (state) => state.auth;
